import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  ocean: {
    label: 'Ocean Pop',
    mode: 'dark',
    background: 'bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(255, 255, 255, 0.13), transparent 33%), linear-gradient(135deg, #1e3a8a 0%, #1e40af 54%, #1d4ed8 100%)'
  },
  graphite: {
    label: 'Graphite Fun',
    mode: 'dark',
    background: 'bg-gradient-to-br from-[#2F3441] via-[#2A2F3C] to-[#232833]',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(255, 255, 255, 0.08), transparent 33%), linear-gradient(135deg, #3a4050 0%, #2f3441 54%, #232833 100%)'
  },
  stormy: {
    label: 'Stormy Fjord',
    mode: 'dark',
    background: 'bg-gradient-to-br from-[#536E88] via-[#445C73] to-[#3B4B60]',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(222, 235, 245, 0.15), transparent 34%), linear-gradient(135deg, #5a748e 0%, #445c73 54%, #3b4b60 100%)'
  },
  harbor: {
    label: 'Deep Harbor',
    mode: 'dark',
    background: 'bg-gradient-to-br from-[#15385E] via-[#0F2742] to-[#0A1D33]',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(111, 181, 224, 0.14), transparent 33%), linear-gradient(135deg, #1a416a 0%, #0f2742 54%, #0a1d33 100%)'
  },
  baltic: {
    label: 'Baltic Blue',
    mode: 'light',
    background: 'bg-gradient-to-br from-[#F5FAFE] via-[#EAF3FB] to-[#D7E8F7]',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(255, 255, 255, 0.9), transparent 34%), linear-gradient(135deg, #f5fafe 0%, #eaf3fb 54%, #d7e8f7 100%)'
  },
  seafoam: {
    label: 'Seafoam Studio',
    mode: 'light',
    background: 'bg-gradient-to-br from-[#F2FCFB] via-[#DFF7F5] to-[#BDE9E4]',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(255, 255, 255, 0.9), transparent 34%), linear-gradient(135deg, #f2fcfb 0%, #dff7f5 54%, #bde9e4 100%)'
  },
  coral: {
    label: 'Coral Coast',
    mode: 'light',
    background: 'bg-gradient-to-br from-[#FFF8F4] via-[#FFF4EE] to-[#FFE1D5]',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(255, 255, 255, 0.88), transparent 34%), linear-gradient(135deg, #fff8f4 0%, #fff4ee 54%, #ffe1d5 100%)'
  },
  nautical: {
    label: 'Nautical Pop',
    mode: 'dark',
    background: 'bg-gradient-to-br from-[#2D73D3] via-[#1E4DB7] to-[#174E94]',
    backgroundImage: 'radial-gradient(circle at 12% 0%, rgba(125, 193, 255, 0.16), transparent 33%), linear-gradient(135deg, #2d73d3 0%, #1e4db7 54%, #174e94 100%)'
  }
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return themes[savedTheme] ? savedTheme : 'ocean';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.className = theme;
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
